import React from "react";

import {
  driftEmptyStateBuilder,
  driftErrorStateBuilder,
  driftLoadingStateBuilder} from 'components/States'

interface Props {
    isEmpty: boolean,
    isLoading: boolean,
    error: boolean,
    table: any
  }


const TableBody: React.FC<Props>  = ({ error, isEmpty, isLoading, table }) => {
  const Error = driftErrorStateBuilder('Something went wrong', 'Please try again')
  const Empty = driftEmptyStateBuilder('There are no deals to show', 'Update your search criteria')
  const Loading = driftLoadingStateBuilder('Loading deals')
  if (error) {
    return <Error />
  }

  if (isEmpty) {
    return <Empty />
  }

  if (isLoading) {
    return <Loading />
  }

  return table
}

export default TableBody
